export const selectApiError = (state) => state.api.error;
